import Card from './Card'
import Button from './Button'

function UpgradePrompt({ title, message, onUpgrade, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <Card className="max-w-md w-full">
        <h2 className="font-heading text-2xl font-bold mb-4">
          {title}
        </h2>
        
        <p className="text-brand-charcoal mb-6">
          {message}
        </p>

        <div className="flex gap-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            className="flex-1"
          >
            Maybe Later
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={onUpgrade}
            className="flex-1"
          >
            Upgrade Now
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default UpgradePrompt


